const defaultState = []
export default (state=defaultState, action) => {
    switch(action.type) {
        case "FETCH_BIBLIOGRAPHY_SUCCESS" : return action.payload
        default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/Bibliography/reducer.js